import { Fragment, useEffect, useState } from "react";
import PageTitle from "../../layouts/PageTitle";
import axios from "axios";
import { Link } from "react-router-dom";
import config from "../../../../config.json";
import Choices from "../AppsMenu/Shop/Choices/Choices";
import "../../../i18n";
import { useTranslation } from "react-i18next";
import "./kitchenLuxe.css";

const ChoicesGrid = () => {
  const { t } = useTranslation();
  const [choices, setChoices] = useState([]);
  const [error, setError] = useState("");
  const [isError, setIsError] = useState(false);
  const [filteredChoices, setFilteredChoices] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");

  const fetchChoices = async () => {
    try {
      const response = await axios.get(`${config.dev}/v2/choices/retrieve`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("tokenLogin")}`,
        },
      });
      const data = response?.data || [];
      setChoices(data);
      setFilteredChoices(data);
      setIsError(false);
    } catch (err) {
      setError("Failed to fetch choices. Please try again later.");
      setIsError(true);
      console.error("Error fetching choices:", err);
    }
  };

  useEffect(() => {
    fetchChoices();
  }, []);

  useEffect(() => {
    const results = choices.filter((item) => {
      const matchesDetails = item.choiceDetails
        ? item.choiceDetails.some((detail) =>
            ["choiceTitle"].some((key) =>
              detail[key]?.toLowerCase().includes(searchTerm.toLowerCase())
            )
          )
        : false;

      return matchesDetails;
    });

    setFilteredChoices(results);
  }, [searchTerm, choices]);

  return (
    <Fragment>
      <div className="kitchen-page" data-tour="tour-page-choices">
        <PageTitle activeMenu={t("choices")} motherMenu={t("kitchen")} />
        <div className="kitchen-toolbar">
          <div className="kitchen-toolbar__search">
            <input
              type="text"
              className="form-control"
              placeholder={t("searchByTitle")}
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
          </div>
          <div className="kitchen-toolbar__actions">
            <Link to={"/add-choice"} className="kitchen-toolbar__add">
              <i className="fas fa-plus" />
              {t("addNewChoice")}
            </Link>
          </div>
        </div>
        <div className="row kitchen-grid">
          {filteredChoices.length === 0 ? (
            <div className="col-12">
              <div className="kitchen-empty" role="alert">
                {isError ? error : t("noDataFound")}
              </div>
            </div>
          ) : (
            filteredChoices.map((choice) => (
              <Choices
                key={choice._id}
                fetchChoices={fetchChoices}
                choice={choice}
              />
            ))
          )}
        </div>
      </div>
    </Fragment>
  );
};

export default ChoicesGrid;
